<template>
    <Box title="接单">
        <van-tabs swipeable background="rgba(0,0,0,0)" line-width="20px" v-model="tabsIndex" @click="propconfirm">
            <van-tab :title="'未接单('+Total+'台)'">
                <div class="tagsBox">
                    <LoadingFooter v-model="loading" :finished="finished" @load="onLoad">
                        <div class="commonItems" v-for="item in List" @click="$router.push({name: 'OrderReceiving', params: {item, hiddenTitle: pageState}})">
                            <div>
                                <img src="@/assets/img/Icon_1.png" />
                                <div>
                                    <p class="ellipsis">{{item.EquName}}</p>
                                    <div>
                                        <div>
                                            <p>资产编号：</p>
                                            <p>规格型号：</p>
                                            <p>使用科室：</p>
                                        </div>
                                        <div>
                                            <p class="ellipsis">{{item.EquCode}}</p>
                                            <p class="ellipsis">{{item.Size}}</p>
                                            <p class="ellipsis">{{item.DepartmentName}}</p>
                                        </div>
                                    </div>
                                </div>
                                <div>
                                    <div>接单</div>
                                </div>
                            </div>
                            <div>
                                <span>启用日期</span>
                                <span>{{item.EnableDate}}</span>
                            </div>
                        </div>
                    </LoadingFooter>
                </div>
            </van-tab>
            <van-tab :title="'已接单('+TotalEd+'台)'">
                <div class="tagsBox">
                    <LoadingFooter v-model="loadingEd" :finished="finishedEd" @load="onLoadEd">
                        <div class="commonItems" v-for="item in ListEd" @click="$router.push({name: 'OrderReceiving', params: {item, hiddenTitle: pageState}})">
                            <div>
                                <img src="@/assets/img/Icon_1.png" />
                                <div>
                                    <p class="ellipsis">{{item.EquName}}</p>
                                    <div>
                                        <div>
                                            <p>资产编号：</p>
                                            <p>设备型号：</p>
                                            <p>使用科室：</p>
                                        </div>
                                        <div>
                                            <p class="ellipsis">{{item.EquCode}}</p>
                                            <p class="ellipsis">{{item.Size}}</p>
                                            <p class="ellipsis">{{item.DepartmentName}}</p>
                                        </div>
                                    </div>
                                </div>
                                <div>
                                    <div>转单</div>
                                </div>
                            </div>
                            <div>
                                <span>启用日期</span>
                                <span>{{item.EnableDate}}</span>
                            </div>
                        </div>
                    </LoadingFooter>
                </div>
            </van-tab>
        </van-tabs>
    </Box>
</template>

<script>
    import Box from '../../components/commonBox/commonBox'
    import {Tab, Tabs} from 'vant'
    import LoadingFooter from '../../components/loadingFooter/loadingFooter'
    export default {
        name: 'OrderReceivingList',
        components: {
            Box,
            LoadingFooter,
            [Tab.name]: Tab,
            [Tabs.name]: Tabs,
        },
        data() {
            return {
                loading: true,
                finished: false,
                List: [],
                page: 1,
                Total: 0,
                tabsIndex:0,//选项卡默认选中

                TotalEd:0,//已接单
                ListEd:[],//已接单列表
                pageEd:1,//已接单页码
                loadingEd:true,
                finishedEd:false,
                pageState:true,
            }
        },
        activated() {
            if(this.tabsIndex===0){
                this.page = 1;
                this.List = [];
                this.loadDataDefault()
            }else{
                this.pageEd = 1;
                this.ListEd = [];
                this.loadDataDefaultEd();
            }
        },
        methods: {
            onLoad() {
                if (!this.loading && !this.finished) {
                    this.page += 1;
                    this.loadDataDefault();
                }
            },
            loadDataDefault() {
                this.$post('api/Dispatch/DispatchList', {
                    RepairStatus: '4',
                    EquCode: '',
                    RepairOrder: '',
                    DepartmentId: '',
                    UserCode: this.$UserInfo.UserId,
                    Store: this.$UserInfo.StoreCode,
                    SortType: '',
                    AssignOrConfirm: '1',
                    StartDate: '',
                    EndDate: '',
                    PageIndex: this.page,
                    PageSize: 10,
                    Token: '123456'
                }).then(result => {
                    this.Total = result.Total;
                    if(result.DispatchList){
                        for (let i = 0; i < result.DispatchList.length||0; i++) {
                            this.List.push(result.DispatchList[i]);
                        }
                    }
                    if (this.page * 10 >= result.Total) {
                        this.loading = false;
                        this.finished = true;
                    } else {
                        this.loading = false;
                        this.finished=true;
                    };
                })
            },propconfirm(){//选项卡点击事件
                if(this.tabsIndex===0){
                    this.pageState=true;
                     this.List.length===0?this.loadDataDefault():'';
                }else
                {
                     this.pageState=false;
                     this.ListEd.length===0?this.loadDataDefaultEd():'';
                }
            },loadDataDefaultEd(){
                this.$post('api/Dispatch/DispatchList', {
                    RepairStatus: '5',
                    EquCode: '',
                    RepairOrder: '',
                    DepartmentId: '',
                    UserCode: this.$UserInfo.UserId,
                    Store: this.$UserInfo.StoreCode,
                    SortType: '',
                    AssignOrConfirm: '1',
                    StartDate: '',
                    EndDate: '',
                    PageIndex: this.pageEd,
                    PageSize: 10,
                    Token: '123456'
                }).then(result => {
                    this.TotalEd = result.Total;
                    if(result.DispatchList){
                        for (let i = 0; i < result.DispatchList.length; i++) {
                            this.ListEd.push(result.DispatchList[i]);
                        }
                        if (this.pageEd * 10 >= result.Total) {
                            this.loadingEd = false;
                            this.finishedEd = true;
                        } else {
                            this.loadingEd = false;
                            this.finishedEd=true;
                        }
                    }else{
                        this.loadingEd = false;
                        this.finishedEd=true;
                    }
                })
            },onLoadEd(){
                if (!this.loadingEd && !this.finishedEd) {
                    this.pageEd += 1;
                    this.loadDataDefaultEd();
                }
            }
        }
    }
</script>

<style scoped lang="scss">
    .tagsBox{
        margin-top: 140px;
    }
</style>



// WEBPACK FOOTER //
// src/page/orderReceivingList/orderReceivingList.vue